<div class="import-step-bar">
  <nav class="import-step-bar__nav" [attr.aria-label]="'TRANS__IMPORT__STEPS__NAV_LABEL' | translate">
    <ol class="import-step-bar__steps">
      @for (step of steps; track step.key; let index = $index) {
        @let state = stateOf(step);
        <li class="import-step-bar__item">
          <button
            type="button"
            class="import-step-bar__step import-step-bar__step--{{ state }}"
            [disabled]="!isOpen(step)"
            [attr.aria-current]="state === 'current' ? 'step' : null"
            (click)="open(step)"
          >
            <span class="import-step-bar__circle">
              @if (state === 'done') {
                <mat-icon class="import-step-bar__check">check</mat-icon>
              } @else {
                {{ index + 1 }}
              }
            </span>
            <span class="import-step-bar__text">
              <span class="import-step-bar__label">{{ step.labelKey | translate }}</span>
              @switch (step.key) {
                @case ('source') {
                  @if (sourceTable && objectTypeName) {
                    <span class="import-step-bar__sublabel">{{ sourceTable }} · {{ objectTypeName | translate }}</span>
                  } @else if (sourceTable) {
                    <span class="import-step-bar__sublabel">{{ sourceTable }}</span>
                  } @else if (objectTypeName) {
                    <span class="import-step-bar__sublabel">{{ objectTypeName | translate }}</span>
                  }
                }
                @case ('mapping') {
                  @if (columnCount) {
                    <span class="import-step-bar__sublabel">
                      {{ 'TRANS__IMPORT__STEPS__MAPPING_SUMMARY' | translate: {
                        lines: mappingLines, used: usedColumns, columns: columnCount
                      } }}
                    </span>
                  }
                }
                @case ('values') {
                  <span class="import-step-bar__sublabel">
                    @if (undecidedValues === null) {
                      {{ 'TRANS__IMPORT__STEPS__VALUES_NOT_SCANNED' | translate }}
                    } @else if (undecidedValues) {
                      {{ (undecidedValues === 1 ? 'TRANS__IMPORT__STEPS__VALUES_UNDECIDED_ONE'
                          : 'TRANS__IMPORT__STEPS__VALUES_UNDECIDED') | translate: {count: undecidedValues} }}
                    } @else {
                      {{ 'TRANS__IMPORT__STEPS__VALUES_ALL_DECIDED' | translate }}
                    }
                  </span>
                }
                @case ('run') {
                  <span class="import-step-bar__sublabel">
                    @if (warnedRows === null) {
                      {{ 'TRANS__IMPORT__STEPS__RUN_NOT_CHECKED' | translate }}
                    } @else if (warnedRows) {
                      {{ (warnedRows === 1 ? 'TRANS__IMPORT__STEPS__RUN_WARNED_ROWS_ONE'
                          : 'TRANS__IMPORT__STEPS__RUN_WARNED_ROWS') | translate: {count: warnedRows} }}
                    } @else {
                      {{ 'TRANS__IMPORT__STEPS__RUN_NO_WARNINGS' | translate }}
                    }
                  </span>
                }
              }
            </span>
          </button>
        </li>
      }
    </ol>
  </nav>

  <div class="import-step-bar__profile">
    @if (profiles.length) {
      <button
        type="button"
        class="import-step-bar__profile-text import-step-bar__profile-pick"
        [matMenuTriggerFor]="pickMenu"
        [disabled]="busy"
      >
        <ng-container *ngTemplateOutlet="profileText; context: {pickable: true}"></ng-container>
      </button>
      <mat-menu #pickMenu="matMenu">
        <button mat-menu-item type="button" (click)="pickProfile.emit(null)">
          <mat-icon>{{ profileId ? '' : 'check' }}</mat-icon>
          <span>{{ 'TRANS__IMPORT__PROFILE__NONE' | translate }}</span>
        </button>
        @for (profile of profiles; track profile.profile_id) {
          <button mat-menu-item type="button" (click)="pickProfile.emit(profile.profile_id)">
            <mat-icon>{{ profile.profile_id === profileId ? 'check' : '' }}</mat-icon>
            <span>{{ profile.profile_name }}</span>
          </button>
        }
      </mat-menu>
    } @else {
      <div class="import-step-bar__profile-text">
        <ng-container *ngTemplateOutlet="profileText; context: {pickable: false}"></ng-container>
      </div>
    }
    <ng-template #profileText let-pickable="pickable">
      <span class="import-step-bar__caption">{{ 'TRANS__IMPORT__VALUE_REVIEW__PROFILE' | translate }}</span>
      <span class="import-step-bar__profile-name" [class.import-step-bar__profile-name--none]="!profileName">
        @if (unsaved) {
          <span
            class="import-step-bar__unsaved-dot"
            role="img"
            [attr.aria-label]="'TRANS__IMPORT__PROFILE__UNSAVED' | translate"
            [matTooltip]="'TRANS__IMPORT__PROFILE__UNSAVED' | translate"
          ></span>
        }
        <span class="import-step-bar__profile-name-text">
          {{ profileName ?? ('TRANS__IMPORT__PROFILE__NONE_LOADED' | translate) }}
        </span>
        @if (pickable) {
          <mat-icon class="import-step-bar__pick-icon">arrow_drop_down</mat-icon>
        }
      </span>
    </ng-template>
    <button
      mat-stroked-button
      type="button"
      color="primary"
      class="import-step-bar__save"
      [disabled]="!unsaved || busy"
      (click)="save.emit()"
    >
      <mat-icon>save</mat-icon>
      <span class="bold uppercase">{{ 'TRANS__IMPORT__PROFILE__SAVE' | translate }}</span>
    </button>
    @if (busy) {
      <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
    }
    <input
      #profileFile
      type="file"
      hidden
      accept=".json,application/json"
      (change)="onProfileFileChosen($event)"
    >
    <button
      mat-icon-button
      type="button"
      class="import-step-bar__more"
      [matMenuTriggerFor]="profileMenu"
      [attr.aria-label]="'TRANS__IMPORT__PROFILE__MORE' | translate"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #profileMenu="matMenu">
      <button mat-menu-item type="button" [disabled]="!canSaveAsNew || busy" (click)="saveAsNew.emit()">
        <mat-icon>save_as</mat-icon>
        <span>{{ 'TRANS__IMPORT__PROFILE__SAVE_AS_NEW' | translate }}</span>
      </button>
      <button mat-menu-item type="button" [disabled]="!profileLoaded || busy" (click)="deleteProfile.emit()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'TRANS__IMPORT__PROFILE__DELETE' | translate }}</span>
      </button>
      <button
        mat-menu-item
        type="button"
        [disabled]="!profileLoaded || unsaved || busy"
        (click)="exportProfile.emit()"
      >
        <mat-icon>download</mat-icon>
        <span>{{ 'TRANS__IMPORT__PROFILE__EXPORT' | translate }}</span>
      </button>
      <button mat-menu-item type="button" [disabled]="busy" (click)="profileFile.click()">
        <mat-icon>upload</mat-icon>
        <span>{{ 'TRANS__IMPORT__PROFILE__IMPORT' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>
